import { create } from 'zustand'

export interface DialogState<T = unknown> {
  open: boolean
  data?: T | null
}

interface DialogStore {
  state: Record<string, DialogState>
  setState: (id: string, open: boolean, data?: unknown) => void
}

export const useDialogStore = create<DialogStore>((set) => ({
  state: {},
  setState: (id, open, data) => {
    set((store) => ({
      state: {
        ...store.state,
        [id]: {
          ...store.state[id],
          open,
          ...(data === undefined ? {} : { data }),
        },
      },
    }))
  },
}))
